import { AuthGuardService } from '../services/auth-guard.service';
import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TrainingCalendarComponent } from './training.calendar/training.calendar.component';
import { TrainingClassComponent } from './training.class/training.class.component';
import { TrainingAttendanceComponent } from './training.attendance/training.attendance.component';

const TrainingRouting: Routes = [
    // login view
    {
        path: 'training', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            { path: 'calendar/:event', component: TrainingCalendarComponent },
            { path: 'classes', component: TrainingClassComponent },
            { path: 'attendance', component: TrainingAttendanceComponent },
			// handle all other routes
            { path: '**', component: TrainingCalendarComponent }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(TrainingRouting)],
    exports: [RouterModule]
})
export class TrainingRoutingModule { }
